import React, { memo, useEffect } from 'react'

import {
  HInput,
  HSelect,
  passParamsThrough,
  DSelect, HCheckbox
} from '../../../validation/HForm'
import {
  cityTypes,
  streetTypes,
  defaultCountry
} from '../../../helpers/data-constants'

const AddressesExpandedAdd = memo(({
  unregister,
  control,
  register,
  errors,
  reset,
  isLoading,
  country,
  handleOptions,
  variableValue,
  tempEntity,
  hPrefixNames
}) => {
  const props = {
    control,
    register,
    errors
  }
  const prefix = hPrefixNames || ""
  
  useEffect(() => {
    reset({
      [`${prefix}region`]: tempEntity?.region,
      [`${prefix}cityType`]: tempEntity?.cityType,
      [`${prefix}city`]: tempEntity?.city,
      [`${prefix}streetType`]: tempEntity?.streetType,
      [`${prefix}street`]: tempEntity?.street,
      [`${prefix}house`]: tempEntity?.house,
      [`${prefix}building`]: tempEntity?.building,
      [`${prefix}apartment`]: tempEntity?.apartment,
      [`${prefix}active`]: tempEntity?.active
    })
    return () => {
      if (unregister) {
        unregister(`${prefix}active`)
      }
    }
  }, [])

  return (
    passParamsThrough(
      <fieldset>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="country">Страна</label>
              <div className="form-element-data combobox">
                <DSelect
                  h="true"
                  name={`${prefix}country`}
                  isLoading={isLoading}
                  options={country}
                  handleOptions={handleOptions}
                  defaultValue={variableValue || defaultCountry}
                  placeholder="Введите страну" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="region">Область</label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}region`}
                  id="region" />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="cityType">Тип населенного пункта</label>
              <div className="form-element-data">
                <HSelect
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}cityType`}
                  id="cityType"
                  options={["", ...cityTypes]} />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="city">Населенный пункт</label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}city`}
                  id="city" />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="streetType">Тип адреса</label>
              <div className="form-element-data">
                <HSelect
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}streetType`}
                  id="streetType"
                  options={["", ...streetTypes]} />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="contactsStreet">Улица</label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}street`}
                  id="street" />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="house">Дом</label>
              <div className="form-element-data number">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}house`}
                  id="house" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="building">Корпус</label>
              <div className="form-element-data number">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}building`}
                  id="building" />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="apartment">Квартира</label>
              <div className="form-element-data number">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name={`${prefix}apartment`}
                  id="apartment" />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientAddCountry">Активен</label>
              <div className="form-element-data">
                <HCheckbox h="true" label="Активен"
                           name="active" />
              </div>
            </div>
          </div>
        </div>

      </fieldset>, props)
  )
})

export default AddressesExpandedAdd
